export default {
  glVoucher: {
    column: {
      info: '基本信息',
      voucherCompany: '公司',
      voucherCompanyCode: '公司代码',
      voucherCompanyName: '公司名称',
      ledgerCode: '账套',
      applicationCode: '模块',
      voucherType: '凭证类型',
      currencyCode: '币种',
      exchangeType: '汇率类型',
      exchangeRate: '汇率',
      exchangeDate: '汇率日期',
      docNo: '单据编号',
      entityDataNo: '业务单据编号',
      postDate: '入账日期',
      calendarPeriod: '期间',
      voucherNo: '凭证编码',
      syncFlag: '入账状态',
      createBy: '创建人',
      createUserName: '操作人',
      gmtCreate: '创建日期',
      sapVoucherNo: 'SAP 凭证编号',
      summary: '备注',
      voucherDate: '凭证日期',
      referenceNo: '参照',

      reverseReason: '冲销原因',
      summaryList: '头备注',
      reverseDocNo: '冲销单据号',
      reverseFlag: '冲销标识',
      reverseDate: '冲销日期',
      chargeAgainsDateForm: '冲销期间',
      reverseVoucherNo: '冲销凭证号',
      reverseSapVoucherNo: '冲销SAP凭证编号',
      originFlag: '凭证来源,M-人工录入的凭证,A-会计引擎生成的凭证',
      syncDate: '同步时间',
      syncResult: '同步结果',
      gmtCreateBegin: '创建日期从',
      gmtCreateEnd: '创建日期至',
      gmtModified: '记录更新时间',
      lastModifiedBy: '记录最后更新人',
      isDeleted: '是否删除(1删除,0未删除)',
      sortNo: '序号',
      version: '版本',
      voucherLocalCurrencyStart: '本币合计金额',
      voucherOriginalCoin: '原币合计金额',
      postDateBegin: '入账日期从',
      postDateEnd: '入账日期至',
      voucherAmount: '原币金额合计',
      drVoucherAmount: '原币借方金额合计',
      crVoucherAmount: '原币贷方金额合计',
      drAccountedVoucherAmount: '本币借方金额合计',
      crAccountedVoucherAmount: '本币贷方金额合计',
      accountedAmount: '本币金额',
      enteredAmount: '原币金额',
      voucherFlag: '按凭证行明细查询',
      voucherDepartment: '部门',
      accountCode: '科目代码',
      cashflowTransactionCode: '现金流量事务代码',
    },
    placeholder: {
      auto: '自动生成',
      natureSideCode: '请选择借贷方',
      pkCode: '请选择过账码',
      accountType: '请选择科目类型',
      accountCode: '请选择科目代码',
      enteredAmount: '请输入原币金额',
      // profitCenterCode: '请选择利润中心代码',
      // costCenterCode: '请选择成本中心代码',

      companyCode: '请输入公司编码',
      departmentCode: '请输入部门编码',
      companyName: '请输入公司名',
      departmentName: '请输入部门名',
      ledgerCode: '请输入账套代码',
      applicationCode: '请输入模块',
      applicationName: '请输入模块名称，字典',
      voucherType: '请选择凭证类型',
      exchangeType: '请选择汇率类型',
      // exchangeRate: '请输入汇率',
      exchangeDate: '请选择汇率日期',
      docNo: '请输入单据编号',
      postDate: '请选择入账日期',
      calendarPeriod: '请输入期间',
      voucherNo: '请输入凭证编号',
      sapVoucherNo: '请输入SAP凭证编号',
      // summary: '请输入摘要',
      reverseReason: '请选择冲销原因',
      reverseDocNo: '请输入冲销单据编号',
      reverseFlag: '请输入冲销标识N,Y',
      reverseDate: '请选择冲销日期',
      reverseVoucherNo: '请输入冲销凭证编号',
      reverseSapVoucherNo: '请输入冲销SAP凭证编号',
      originFlag: '请输入凭证来源,M-人工录入的凭证,A-会计引擎生成的凭证',
      syncDate: '请选择同步时间',
      syncFlag: '请输入同步状态',
      syncResult: '请输入同步结果',
      voucherId: '请输入凭证id',
      enteredDrAmount: '请输入原币借方金额',
      enteredCrAmount: '请输入原币贷方金额',
      accountedDrAmount: '请输入本币借方金额',
      accountedCrAmount: '请输入本币贷方金额',
      profitCenterCode: '请输入利润中心',
      profitCenterName: '请输入利润中心名称',
      costCenterCode: '请输入成本中心',
      costCenterName: '请输入成本中心名称',
      cashflowTransactionCode: '请输入现金流量事务代码',
      cashflowTransactionName: '请输入现金流量事务名称',
      currencyCode: '请输入币种代码',
      exchangeRate: '请输入汇率',
      summary: '请输入摘要',
      bankAccountNum: '请输入银行账户号码',
      bankName: '请输入开户行名称',
      partnerCode: '请输入合作伙伴编码',
      partnerZhName: '请输入合作伙伴中文名称',
      customerCode: '请输入客户',
      supplierCode: '请输入供应商',
      externalCustomerCode: '请输入外部客户',
      maturityDate: '请选择到期日',
      loanNature: '请输入借款性质(字典)',
      createBy: '请选择创建人',
      gmtCreate: '请选择记录创建时间',
      gmtModified: '请选择记录更新时间',
      lastModifiedBy: '请输入记录最后更新人',
      isDeleted: '请输入是否删除(1删除,0未删除)',
      sortNo: '请输入序号',
      version: '请输入版本',
      chargeAgainsDateForm: '请输入冲销期间',
    },
    reverse: {
      info: '冲销信息',
      reverseDocNo: '冲销单据号',
      reverseFlag: '冲销标识',
      reverseDate: '冲销日期',
      chargeAgainsDateForm: '冲销期间',
      reverseVoucherNo: '冲销凭证号',
    },
    table: {
      info: '行信息',
      sortNo: '序号',
      natureSideCode: '借贷方',
      pkCode: '过账码',
      accountType: '科目类型',
      accountCode: '科目代码',
      accountDesc: '科目说明',
      enteredAmount: '原币金额',
      accountedAmount: '本币金额',
      profitCenterCode: '利润中心代码',
      profitCenterName: '利润中心名称',
      costCenterCode: '成本中心代码',
      costCenterName: '成本中心名称',
      cashflowTransactionCode: '现金流量事务代码',
      cashflowTransactionName: '现金流量事务名称',
      currencyCode: '币种',
      exchangeRate: '汇率',
      summary: '备注',
      bankAccountNum: 'SAP账户标识',
      bankName: '开户行名称',
      partnerCode: '合作伙伴编码',
      partnerZhName: '合作伙伴中文名称',
      customerCode: '辅核-客户',
      supplierCode: '辅核-供应商',
      externalCustomerCode: '外部客户',
      maturityDate: '到期日',
      loanNature: '借款性质',
      batchNo: '批次/评估类型',
      businessQuantity: '数量',
      businessUnit: '单位',
      orderNo: '采购订单号',
      orderDetailNo: '采购订单行号',
      salesOrderNo: '销售订单号',
      salesOrderItem: '销售订单行号',
      productCategory: '商品分类',
      externalContractNo: '外部合同号',
      invoiceNo: '发票号',
      totalD: '借方合计',
      totalC: '贷方合计',
      departmentCode: '部门代码',
      departmentName: '部门名称',
      materialCode: '商品编码',
      sapBankCode: 'SAP开户银行',
      sglCode: '特别总账标识',
      negativeFlag: '反记账标识',
      zzboeno: '物料号',
      contractNo: '贸易合同号',
      baseQuantity: '基本数量',
      baseUnit: '基本计量单位',
      payCondition: '付款条件代码',
      paymentMethod: '付款方式',
      plant: '工厂',
      assignmentNo: '分配号',
      taxCode: '税码',
    },
    button: {
      excel: 'Excel导入',
      save: '保存',
      delete: '删除',
      accountEntry: '入账',
      writeOff: '冲销',
      voucherPreview: '凭证预览',
    },
    route: {
      collectBillAdd: '应收票据创建',
      collectBillEdit: '应收票据修改',
      collectBillDetails: '应收票据详情',
      collectBillList: '应收票据',
      payBillAdd: '应付票据创建',
      payBillEdit: '应付票据修改',
      payBillDetails: '应付票据详情',
      payBillList: '应付票据',
    },
    message: {
      ledgerInfo: '请先配置公司账套',
      rateInfo: '缺少对应汇率，请维护',
      requireContent: '请补充完整必填内容',
      accountEntryAmount: '借贷方总金额不一致，请修改',
      accountEntryDate: '入账日期不属于打开的期间，请修改',
      noSelectData: '请至少选择一条数据进行操作',
      onlyOneSelectData: '请选择一条数据进行操作',
      noExport: '当前没有数据可以导出！',
      noSelected: '您还未选择任何数据!',
      noCanDelSelectData: '所选数据中没有可删除的状态，请重新选择！',
      hasCannotDelTip: '所选数据中有不可删除的数据，点击确认只会删除未入账和入账失败状态的数据！',
      noDelect: '只有已登记数据可以删除，请重新选择！',
      noNatureSide: '请先选择借贷方！',
      noAccountType: '请先选择科目类型！',
      noData: '您还未选择任何数据！',
      cancelled: '已取消！',
      isNotOpenPeriod: '入账日期不属于打开的期间，请重新选择！',
      sumVerify: '借方合计金额必需等于贷方合计金额！',
    },
    status: {
      yes: '是',
      no: '否',
      pledge: '质押',
      noPledge: '未质押',
      assignment: '转让',
      noAssignment: '非转让',
    },
  },
  queryVoucherList: {
    route: {
      collectBillAdd: '应收票据创建',
      collectBillEdit: '应收票据修改',
      collectBillDetails: '应收票据详情',
      collectBillList: '应收票据',
      payBillAdd: '应付票据创建',
      payBillEdit: '应付票据修改',
      payBillDetails: '应付票据详情',
      payBillList: '应付票据',
    },
    tips: {
      noSelectData: '请至少选择一条数据进行操作',
      onlyOneSelectData: '请选择一条数据进行操作',
      noExport: '当前没有数据可以导出！',
      noDelect: '只有已登记数据可以删除，请重新选择！',
    },
    status: {
      yes: '是',
      no: '否',
      pledge: '质押',
      noPledge: '未质押',
      assignment: '转让',
      noAssignment: '非转让',
    },
  },
  addVoucher: {
    searchBase: {
      info: '基本信息',
      tenantCode: '租户编码',
      companyCode: '公司编码',
      departmentCode: '部门编码',
      companyName: '公司名',
      departmentName: '部门名',
      ledgerCode: '账套',
      applicationCode: '模块',
      applicationName: '模块名称，字典',
      voucherType: '凭证类型',
      currencyCode: '币种',
      exchangeType: '汇率类型',
      exchangeRate: '汇率',
      exchangeDate: '汇率日期',
      docNo: '单据编号',
      entityDataNo: '业务单据编号',
      postDate: '入账日期',
      calendarPeriod: '期间',
      voucherNo: '凭证编号',
      sapVoucherNo: 'SAP凭证编号',
      summary: '摘要',
      summaryList: '头备注',
      reverseDocNo: '冲销单据号',
      reverseFlag: '冲销标识',
      reverseDate: '冲销日期',
      reverseVoucherNo: '冲销凭证号',
      reverseSapVoucherNo: '冲销SAP凭证编号',
      originFlag: '凭证来源,M-人工录入的凭证,A-会计引擎生成的凭证',
      syncDate: '同步时间',
      syncFlag: '入账状态',
      syncResult: '同步结果',
      createBy: '创建人',
      gmtCreateBegin: '创建日期从',
      gmtCreateEnd: '创建日期至',
      gmtModified: '记录更新时间',
      lastModifiedBy: '记录最后更新人',
      isDeleted: '是否删除(1删除,0未删除)',
      sortNo: '序号',
      version: '版本',
      voucherLocalCurrencyStart: '本币合计金额',
      voucherOriginalCoin: '原币合计金额',
      postDateBegin: '入账日期从',
      postDateEnd: '入账日期至',
      accountedAmount: '本币金额',
      enteredAmount: '原币金额',
      voucherFlag: '按凭证行明细查询',
      voucherDepartment: '部门',
    },
    placeholder: {
      tenantCode: '请输入租户编码',
      companyCode: '请输入公司编码',
      departmentCode: '请输入部门编码',
      companyName: '请输入公司名',
      departmentName: '请输入部门名',
      ledgerCode: '请输入账套代码',
      applicationCode: '请输入模块',
      applicationName: '请输入模块名称，字典',
      voucherType: '请选择凭证类型',
      // currencyCode: '请输入币种代码',
      exchangeType: '请选择汇率类型',
      // exchangeRate: '请输入汇率',
      exchangeDate: '请选择汇率日期',
      docNo: '请输入单据编号',
      postDate: '请选择入账日期',
      calendarPeriod: '请输入期间',
      voucherNo: '请输入凭证编号',
      sapVoucherNo: '请输入SAP凭证编号',
      // summary: '请输入摘要',
      reverseDocNo: '请输入冲销单据编号',
      reverseFlag: '请输入冲销标识N,Y',
      reverseDate: '请选择冲销日期',
      reverseVoucherNo: '请输入冲销凭证编号',
      reverseSapVoucherNo: '请输入冲销SAP凭证编号',
      originFlag: '请输入凭证来源,M-人工录入的凭证,A-会计引擎生成的凭证',
      syncDate: '请选择同步时间',
      syncFlag: '请输入同步状态',
      syncResult: '请输入同步结果',

      voucherId: '请输入凭证id',
      accountCode: '请输入科目代码',
      accountDesc: '请输入科目名称',
      enteredDrAmount: '请输入原币借方金额',
      enteredCrAmount: '请输入原币贷方金额',
      accountedDrAmount: '请输入本币借方金额',
      accountedCrAmount: '请输入本币贷方金额',
      profitCenterCode: '请输入利润中心',
      profitCenterName: '请输入利润中心名称',
      costCenterCode: '请输入成本中心',
      costCenterName: '请输入成本中心名称',
      cashflowTransactionCode: '请输入现金流量事务代码',
      cashflowTransactionName: '请输入现金流量事务名称',
      currencyCode: '请输入币种代码',
      exchangeRate: '请输入汇率',
      summary: '请输入摘要',
      bankAccountNum: '请输入银行账户号码',
      bankName: '请输入开户行名称',
      partnerCode: '请输入合作伙伴编码',
      partnerZhName: '请输入合作伙伴中文名称',
      customerCode: '请输入客户',
      supplierCode: '请输入供应商',
      externalCustomerCode: '请输入外部客户',
      maturityDate: '请选择到期日',
      loanNature: '请输入借款性质(字典)',
      createBy: '请选择创建人',
      gmtCreate: '请选择记录创建时间',
      gmtModified: '请选择记录更新时间',
      lastModifiedBy: '请输入记录最后更新人',
      isDeleted: '请输入是否删除(1删除,0未删除)',
      sortNo: '请输入序号',
      version: '请输入版本',
    },
    search: {
      info: '冲销信息',
      reverseDocNo: '冲销单据编号',
      reverseFlag: '冲销标识',
      reverseDate: '冲销日期',
      reverseVoucherNo: '冲销凭证编号',
    },
  },
};
